<template>
  <div class="business-page">
    <Header />
    <!-- Banner -->
    <div class="business-banner robot-banner">
      <div class="banner-content">
        <h1 class="banner-title">机器人业务</h1>
        <p class="banner-subtitle">智能机器人赋能智慧场景，助力企业自动化升级</p>
      </div>
    </div>

    <!-- 智能巡检机器人 -->
    <div class="business-section">
      <div class="section-container">
        <div class="robot-block">
          <div class="block-content">
            <div class="content-header">
              <h2 class="content-title">智能巡检机器人</h2>
              <p class="content-desc">无人值守智能巡检，实时监控，异常预警，保障生产安全</p>
            </div>
            <div class="capability-list">
              <div class="capability-item">
                <div class="capability-icon">🧭</div>
                <div class="capability-text">
                  <div class="capability-name">自主导航</div>
                  <div class="capability-detail">激光SLAM导航，自主规划路径</div>
                </div>
              </div>
              <div class="capability-item">
                <div class="capability-icon">👁️</div>
                <div class="capability-text">
                  <div class="capability-name">智能识别</div>
                  <div class="capability-detail">AI视觉识别，异常检测</div>
                </div>
              </div>
              <div class="capability-item">
                <div class="capability-icon">🚨</div>
                <div class="capability-text">
                  <div class="capability-name">实时预警</div>
                  <div class="capability-detail">异常情况即时上报</div>
                </div>
              </div>
              <div class="capability-item">
                <div class="capability-icon">📊</div>
                <div class="capability-text">
                  <div class="capability-name">数据分析</div>
                  <div class="capability-detail">巡检数据统计与分析</div>
                </div>
              </div>
            </div>
          </div>
          <div class="block-image">
            <div class="placeholder-image large">
              <div class="placeholder-text">智能巡检机器人</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 智能巡检机器人应用场景 -->
    <div class="business-section section-gray">
      <div class="section-container">
        <div class="section-title">应用场景</div>
        <div class="scenario-grid">
          <div class="scenario-card">
            <div class="scenario-icon">🏭</div>
            <div class="scenario-name">工厂巡检</div>
            <div class="scenario-desc">设备状态监控、环境检测</div>
          </div>
          <div class="scenario-card">
            <div class="scenario-icon">🖥️</div>
            <div class="scenario-name">机房巡检</div>
            <div class="scenario-desc">服务器状态、温湿度监测</div>
          </div>
          <div class="scenario-card">
            <div class="scenario-icon">🏢</div>
            <div class="scenario-name">园区巡检</div>
            <div class="scenario-desc">安防巡逻、设施检查</div>
          </div>
          <div class="scenario-card">
            <div class="scenario-icon">⚡</div>
            <div class="scenario-name">配电房巡检</div>
            <div class="scenario-desc">电力设备状态监测</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 零售服务机器人 -->
    <div class="business-section">
      <div class="section-container">
        <div class="robot-block reverse">
          <div class="block-image">
            <div class="placeholder-image large">
              <div class="placeholder-text">零售服务机器人</div>
            </div>
          </div>
          <div class="block-content">
            <div class="content-header">
              <h2 class="content-title">零售服务机器人</h2>
              <p class="content-desc">智能导购、自助配送，提升门店服务体验与运营效率</p>
            </div>
            <div class="capability-list">
              <div class="capability-item">
                <div class="capability-icon">🛍️</div>
                <div class="capability-text">
                  <div class="capability-name">智能导购</div>
                  <div class="capability-detail">商品查询、智能推荐</div>
                </div>
              </div>
              <div class="capability-item">
                <div class="capability-icon">📦</div>
                <div class="capability-text">
                  <div class="capability-name">商品配送</div>
                  <div class="capability-detail">自动配送、货架补货</div>
                </div>
              </div>
              <div class="capability-item">
                <div class="capability-icon">🎯</div>
                <div class="capability-text">
                  <div class="capability-name">互动营销</div>
                  <div class="capability-detail">客户互动、促销活动</div>
                </div>
              </div>
              <div class="capability-item">
                <div class="capability-icon">📈</div>
                <div class="capability-text">
                  <div class="capability-name">数据采集</div>
                  <div class="capability-detail">顾客行为数据收集</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 零售机器人应用场景 -->
    <div class="business-section section-gray">
      <div class="section-container">
        <div class="section-title">应用场景</div>
        <div class="scenario-grid">
          <div class="scenario-card">
            <div class="scenario-icon">🏬</div>
            <div class="scenario-name">商场导购</div>
            <div class="scenario-desc">导航指引、品牌介绍</div>
          </div>
          <div class="scenario-card">
            <div class="scenario-icon">🛒</div>
            <div class="scenario-name">超市配送</div>
            <div class="scenario-desc">商品配送、订单履约</div>
          </div>
          <div class="scenario-card">
            <div class="scenario-icon">🏪</div>
            <div class="scenario-name">便利店服务</div>
            <div class="scenario-desc">自助结算、商品推荐</div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import metaInfo from "@/common/util/metaInfo";

export default {
  metaInfo: metaInfo.robot,
  components: {
    Header,
    Footer,
  },
  name: 'BusinessRobot',
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.business-page {
  width: 100%;
}

.business-banner {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1763FF 0%, #3986FF 100%);
}

.robot-banner {
  background: linear-gradient(135deg, #0066CC 0%, #1763FF 100%);
}

.banner-content {
  text-align: center;
  color: #FFFFFF;
}

.banner-title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
}

.banner-subtitle {
  font-size: 20px;
  opacity: 0.9;
}

.business-section {
  padding: 80px 0;
}

.section-gray {
  background: #F8F9FA;
}

.section-container {
  width: 1200px;
  margin: 0 auto;
}

.robot-block {
  display: flex;
  gap: 60px;
  align-items: center;
}

.robot-block.reverse {
  flex-direction: row-reverse;
}

.block-content {
  flex: 1;
}

.content-header {
  margin-bottom: 40px;
}

.content-title {
  font-size: 32px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 16px;
}

.content-desc {
  font-size: 16px;
  color: #595859;
  line-height: 24px;
}

.capability-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.capability-item {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.capability-icon {
  font-size: 32px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F3F4FB;
  border-radius: 8px;
  flex-shrink: 0;
}

.capability-name {
  font-size: 18px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 4px;
}

.capability-detail {
  font-size: 14px;
  color: #595859;
}

.block-image {
  flex: 1;
}

.placeholder-image {
  width: 100%;
  background: #F3F4FB;
  border-radius: 12px;
  overflow: hidden;
}

.placeholder-image.large {
  height: 500px;
}

.placeholder-text {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #1763FF;
  font-weight: 600;
}

.section-title {
  font-size: 32px;
  font-weight: 600;
  color: #222222;
  text-align: center;
  margin-bottom: 50px;
}

.scenario-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.scenario-card {
  padding: 30px 20px;
  background: #FFFFFF;
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s;
}

.scenario-card:hover {
  transform: translateY(-8px);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
}

.scenario-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.scenario-name {
  font-size: 18px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 8px;
}

.scenario-desc {
  font-size: 14px;
  color: #595859;
}
</style>
